<template>
    <div class="warp">
        <div class="menu_box">
            <div class="nav_box">
                <el-menu :default-active='activeIndex' mode="horizontal" class="el-menu-demo">
                    <el-menu-item index="1" @click="toVideo">视频</el-menu-item>
                    <el-menu-item index="2" @click="toImage">图片</el-menu-item>
                </el-menu>
            </div>
            <!-- <div class="volume_box" ref="capacity_progress_bar"> -->
            <div class="volume_box">
                <div :style="progressBarWidth"></div>
                <div>{{usesizetext}}/{{totalcapacity}}</div>
            </div>
        </div>
        <div class="video">
            <div class="left_menu_box">
                <!-- <div class="top_box" :class="leftMenuIsSelect == -1 ? 'is_select' : 'no_select'" @click="leftMenuClick(-1)">全部视频</div> -->
                <div class="video_list" v-for="(item,index) of videoCollection" :key="index" :class="leftMenuIsSelect == index ? 'is_select' : 'no_select'" @click="leftMenuClick(index, item.catalogid)">
                    <div>
                        <span class="el-dropdown-link" v-if="index == 0">
                           {{item.catename}}
                            <i style="display: inline-block;width: 24px;"></i>
                        </span>
                        <el-dropdown v-else>
                            <span class="el-dropdown-link">
                               {{item.catename}}
                                <i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="rename(index, item.catalogid, item.catename)">重命名</el-dropdown-item>
                                <el-dropdown-item @click.native="delVideoCollection(index, item.catalogid)">删除</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <div class="add_box" :class="leftMenuIsSelect == -2 ? 'is_select' : 'no_select'" @click="leftMenuClick(-2)">
                    <img :src="addIcon" alt="">
                    <span>增加视频合集</span>
                </div>
            </div>
            <el-dialog title="重命名" :visible.sync="reNameCollTips">
                <el-input v-model="newName" placeholder="请输入名称"></el-input>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="reNameCollTips = false">取 消</el-button>
                    <el-button type="primary" @click="sureRename()">确 定</el-button>
                </div>
            </el-dialog>
            <el-dialog title="增加视频合集" :visible.sync="addVideoCollection">
                <el-input v-model="params.name" placeholder="请输入新视频合集名称"></el-input>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="addVideoCollection = false">取 消</el-button>
                    <el-button type="primary" @click="sureAddClick()">确 定</el-button>
                </div>
            </el-dialog>
            <div class="right_main_box">
                <div class="top" v-show="leftMenuIsSelect === 0" v-if="permission.btnList.indexOf('A070001')==-1">
                    <div class="left_box">
                        <div class="upload_box">
                            <uploadFile v-if="checkDisabled === false" :checkDisabled="checkDisabled" :uploadType="uploadType" @setFile="setFile" :fileRule="fileRule" ref="uploadFile"></uploadFile>
                            <el-button v-else-if="checkDisabled === true" type="primary" disabled>上传视频</el-button>
                        </div>
                        <div class="tips_box">
                            <span style="color: #FA5555"> * </span> 支持主流的视频格式：3GP、AVI、FLV、MP4、MPG、ASF、WMV、MKV、MOV、TS等 *上传视频大小不超过5G ，视频上传后会转码成高清的通用格式视频文件
                        </div>
                    </div>
                    <div class="right_box">
                        <!-- <span>转码列表</span>
                        <button>0</button>
                        <span>上传列表</span>
                        <button>0</button> -->
                    </div>
                </div>
                <div class="video_content_list">
                    <div class="no_content" v-show="videoListData.length == 0">
                        <span>暂无内容</span>
                    </div>
                    <div class="video_content_box" v-show="videoListData.length !== 0">
                        <div class="video_box">
                            <div class="video_item" v-for="(item,index) of videoListData" :key="index">
                                <div>
                                    <div class="video_item_box">
                                        <img v-lazy="item.coveratturl" alt="">
                                        <span>{{playTime(item.videolength)}}</span>
                                    </div>
                                    <div class="play_video_box" @click="playVideoClick(item.fileatturl, item.coveratturl)">
                                        <img :src="testImg2" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div>{{item.name}}</div>
                                    <div>
                                        <label>{{item.datetime}}</label>
                                        <span @click="classifyClick(item.innerid)">分类</span>
                                        <span @click="downloadClick(item.fileatturl)">下载</span>
                                        <span @click="editClick(item.innerid, item.name, item.coveratturl)">编辑</span>
                                        <span v-if="!currentPageGroupId" @click="allDelete(item.innerid)">删除</span>
                                        <span v-else-if="currentPageGroupId" @click="delClick(item.innerid)">移除</span>
                                    </div>
                                </div>
                            </div>
                            <el-dialog title="编辑信息" :visible.sync="editTips">
                                <div class="edit_box">
                                    <div class="left_box">
                                        <div>
                                            <upload class="headImage" :imgRule="imgRule"  @setImage="setCoverfile" :uploadType="uploadImgType" ref="coverfile"></upload>
                                            <span>点击图片更换封面</span>
                                        </div>
                                    </div>
                                    <div class="right_box">
                                        <el-input type="textarea" :rows="2" v-model="videoNewName"></el-input>
                                    </div>
                                </div>
                                <div slot="footer" class="dialog-footer">
                                    <el-button @click="editTips = false">取 消</el-button>
                                    <el-button type="primary" @click="sureEdit()">确 定</el-button>
                                </div>
                            </el-dialog>
                            <el-dialog title="分类" :visible.sync="classifyTips">
                                <div class="classify_box">
                                    <el-checkbox-group v-model="checkList">
                                        <el-checkbox v-for="item in videoCollection" :key="item.catalogid" :label="item.catalogid">{{item.catename}}</el-checkbox>
                                    </el-checkbox-group>
                                </div>
                                <div slot="footer" class="dialog-footer">
                                    <el-button @click="classifyTips = false">取 消</el-button>
                                    <el-button type="primary" @click="sureClassify()">确 定</el-button>
                                </div>
                            </el-dialog>
                            <el-dialog title="视频下载" :visible.sync="downloadTips">
                                <div class="download_box">
                                    <div v-show="showEscapeBtn">当前视频还未转码，无法下载</div>
                                    <div v-show="showDownloadBtn">
                                        <p>{{escapeText}}</p>
                                        <el-progress :text-inside="true" :stroke-width="24" :percentage="progress"></el-progress>
                                    </div>
                                </div>
                                <div slot="footer" class="dialog-footer">
                                    <el-button v-show="showEscapeBtn" @click="escapeBtn">转 码</el-button>
                                    <el-button :disabled="progress < 100" v-show="showDownloadBtn" class="download_btn" type="primary" @click="sureDownload()">下 载</el-button>
                                </div>
                            </el-dialog>
                        </div>
                        <div class="page">
                            <el-pagination
                                background
                                @current-change="handleSizeChange"
                                :current-page.sync="pageParams.page"
                                :page-size="pageParams.pageSize"
                                :pager-count="11"
                                layout="prev, pager, next"
                                :total="total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
            <div class="video_tips" v-show="isShowVideoTips">
                <div>
                    <img @click="closeVideoClick" :src="closeIcon" alt="">
                    <video width="960" :src='videoUrl' controls autoplay :poster="videoCoverUrl"></video>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getAllCapacity, addCollection, getColList, videoColReName, delMaterial, wholedelete, delMaterialGroup, findAllVideo, uploadVideo, updateVideoName, findGroupVideo, videoClassify} from 'api/materialMgtApi'
import {mapGetters, mapActions} from 'vuex'
import Upload from 'base/upload/upload'
import UploadFile from 'base/upload/uploadFileResume'
import {formatFileInfo} from 'common/js/tools'
import _ from 'lodash'
export default {
    data() {
        return {
            checkDisabled: false,
            totalcapacity: '0GB',
            usesizetext: '0MB',
            progressBarWidth: 'width: 1%;',
            activeIndex: '1',
            imgRule: {
                cls: 'icon_upload',
                accept: 'image/png,image/jpeg',
                size: 10,
                width: '',
                height: ''
            },
            uploadImgType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            fileRule: {
                btnName: '上传视频',
                cls: '',
                accept: 'video/mp4',
                size: 2000,
                width: '',
                height: ''
            },
            uploadType: {
                catecode: '92',
                datatype: 'VIDEO'
            },
            total: 0,
            pageParams: {
                page: 1,
                pageSize: 20
            },
            addIcon: require('@/common/images/other/icon_upload@2x.png'),
            closeIcon: require('@/common/images/other/close.png'),
            testImg: require('@/common/images/logo.png'),
            testImg2: require('@/common/images/other/video_play.png'),
            leftMenuIsSelect: 0, // 当前选中左侧菜单
            videoCollection: [], // 左侧视频合集菜单
            addVideoCollection: false, // 新增视频合集提示框
            catalogInnerId: '', // 素材分类的innerid
            newName: '', // 新合集名称
            videoNewName: '', // 单个素材新名称
            videoId: '', // 素材的innerid
            params: {
                name: '', // 视频合集名称
                type: 1
            },
            reNameCollTips: false, // 重命名视频合集提示框
            videoListData: [], // 右侧视频列表
            editTips: false, // 编辑弹窗
            classifyTips: false, // 分类弹窗
            downloadTips: false, // 下载弹窗
            escapeText: '正在转码',
            showDownloadBtn: false,
            showEscapeBtn: true,
            progress: 0,
            checkList: [],
            classVideoId: '', // 分类视频ID
            isShowVideoTips: false,
            videoUrl: '',
            videoCoverUrl: '',
            groupId: '', // 分类ID
            coverPicture: '',
            currentPageGroupId:'',//当前页面上显示数据的分组id
            renameIndex: '' // 当前重命名的索引
        }
    },
    mounted() {
        if (_.endsWith(this.$route.path, 'video')) {
            this.activeIndex = '1'
        } else {
            this.activeIndex = '2'
        }
        // this.getColListData()
        this.getAllVideo()
        this.findAllCapacity()
    },
    methods: {
        toVideo() {
            this.$router.push({name: 'Video'})
        },
        toImage() {
            this.$router.push({name: 'Image'})
        },
        findAllCapacity() {
            this.setLoading(true)
            getAllCapacity({
                success: data => {
                    this.setLoading(false)
                    this.progressBarWidth = `width: ${data.data.percent};`
                    this.totalcapacity = data.data.totalcapacitytext
                    this.usesizetext = data.data.usesizetext
                    if (parseFloat(data.data.usesize) < parseFloat(data.data.totalcapacity)) {
                        this.checkDisabled = false
                    } else {
                        this.checkDisabled = true
                    }
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 设置封面信息（本地）
        setCoverfile(img) {
            this.coverPicture = img
            console.log(this.coverPicture)
        },
        playTime(value) {
            var secondTime = value // 秒
            var minuteTime = 0 // 分
            var hourTime = 0 // 小时
            if (secondTime > 60) { // 如果秒数大于60，将秒数转换成整数
                // 获取分钟，除以60取整数，得到整数分钟
                minuteTime = parseInt(secondTime / 60)
                // 获取秒数，秒数取佘，得到整数秒数
                secondTime = parseInt(secondTime % 60)
                // 如果分钟大于60，将分钟转换成小时
                if (minuteTime > 60) {
                    // 获取小时，获取分钟除以60，得到整数小时
                    hourTime = parseInt(minuteTime / 60)
                    // 获取小时后取佘的分，获取分钟除以60取佘的分
                    minuteTime = parseInt(minuteTime % 60)
                }
            }
            if (secondTime < 10) {
                secondTime = `0${secondTime}`
            }
            if (minuteTime < 10) {
                minuteTime = `0${minuteTime}`
            }
            if (hourTime < 10) {
                hourTime = `0${hourTime}`
            }
            var result = `${hourTime}:${minuteTime}:${secondTime}`
            return result
        },
        // 播放视频弹窗
        playVideoClick(value, value2) {
            this.isShowVideoTips = true
            this.videoUrl = value
            this.videoCoverUrl = value2
        },
        // 关闭视频弹窗
        closeVideoClick() {
            this.videoUrl = ''
            this.isShowVideoTips = false
        },
        // 分页
        handleSizeChange(val) {
            // this.params.page = val
            console.log(this.params)
            this.pageParams.page = val
            var params = {
                catalogInnerId: this.groupId
            }
            this.setLoading(true)
            findAllVideo({
                data: Object.assign({}, params, this.pageParams),
                success: data => {
                    this.setLoading(false)
                    this.videoListData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 上传视频
        setFile(file) {
            // console.log('file:', file)
            var params = {
                vsource: 1,
                keyid: '',
                imageinfo: formatFileInfo(file)
            }
            this.setLoading(true)
            uploadVideo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    if (data.code === '000') {
                        this.$message.success(`上传视频成功`)
                        this.getAllVideo()
                        this.findAllCapacity()
                        // window.location.reload()
                        // this.$nextTick(() => {
                        //     this.getAllVideo()
                        // })
                    }
                    this.$refs.uploadFile.initUploadParam()
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 点击选中左侧菜单 添加背景色及相关操作
        leftMenuClick(value, id) {
            this.leftMenuIsSelect = value
            this.groupId = id
            this.pageParams.page = 1
            // if (value === -1) {
            //     this.getAllVideo()
            //     this.groupId = ''
            //     return
            // }
            if (value === -2) {
                this.groupId = ''
                this.params.name = '' // 重置新增合集名称
                this.addVideoCollection = true
                return
            } else {
                this.currentPageGroupId=id
            }
            this.getGroupVideo(this.groupId)
        },
        getGroupVideo(value) {
            this.setLoading(true)
            var params = {
                catalogInnerId: value
            }
            findGroupVideo({
                data: Object.assign({}, params, this.pageParams),
                success: data => {
                    this.setLoading(false)
                    this.videoListData = data.data.content
                    if (this.pageParams.page === 1) {
                        this.total = data.data.pageinfo.rowCount
                    }
                    // this.total = data.pageableData.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 新增视频合集
        sureAddClick() {
            if (this.params.name === '') {
                this.$message.error(`新视频合集名称不能为空`)
                return
            }
            this.setLoading(true)
            addCollection({
                data: Object.assign({}, this.params),
                success: data => {
                    this.setLoading(false)
                    // console.log('新增合集:', data)
                    this.leftMenuIsSelect = 0
                    // this.getColListData()
                    this.getAllVideo()
                    this.currentPageGroupId = ''
                    this.groupId = ''
                    this.addVideoCollection = false
                    this.$message.success(`新增视频合集成功`)
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 分类弹窗
        classifyClick(value) {
            this.classifyTips = true
            this.classVideoId = value
            this.checkList = []
            console.log('分类弹窗:', value)
        },
        // 确定分类
        sureClassify() {
            this.setLoading(true)
            var params = {
                catalogInnerId: this.checkList.join(','), // 图片分类的innerid
                materiaIds: this.classVideoId // 单个加入分类图片的innerid
            }
            videoClassify({
                url: `/api/admin/material/catalog/catalogInnerId/video`,
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    // console.log('上传图片data:', data)
                    if (data.code === '000') {
                        this.getAllVideo()
                        this.$message.success(`分类成功`)
                        this.classifyTips = false
                    }
                    // this.$refs.uploadFile.initUploadParam()
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 下载弹窗
        downloadClick(value) {
            // this.downloadTips = true
            // this.showEscapeBtn = true
            // this.showDownloadBtn = false
            // this.progress = 0
            fetch(value).then(res => res.blob()).then(blob => {
                console.log(blob)
                const a = document.createElement('a')
                document.body.appendChild(a)
                a.style.display = 'none'
                // 使用获取到的blob对象创建的url
                const url = window.URL.createObjectURL(blob)
                a.href = url
                // 指定下载的文件名
                a.download = '测试.mp4'
                a.click()
                document.body.removeChild(a)
                // 移除blob对象的url
                window.URL.revokeObjectURL(url)
            })
        },
        // 弹窗内转码按钮
        escapeBtn() {
            this.$message.success(`开始转码!`)
            this.showEscapeBtn = false
            this.showDownloadBtn = true
            var that = this
            var tiemr = setInterval(() => {
                that.progress = that.progress + 1
                if (that.progress === 100) {
                    that.progress = 100
                    clearInterval(tiemr)
                }
            }, 100)
        },
        // 弹窗内下载按钮
        sureDownload() {
            this.$message.success(`开始下载!`)
        },
        // 编辑弹窗
        editClick(id, name, img) {
            this.videoId = id
            this.videoNewName = name
            this.coverPicture = ''
            this.editTips = true
            this.$nextTick(() => {
                this.$refs.coverfile.setImage(img)
            })
        },
        // 确定编辑
        sureEdit() {
            if (this.videoNewName === '') {
                this.$message.error(`视频名不能为空！`)
                return
            }
            this.setLoading(true)
            var imgeinfoValue = this.coverPicture
            if (imgeinfoValue !== '') {
                imgeinfoValue = formatFileInfo(imgeinfoValue)
            }
            var params = {
                imgeinfo: imgeinfoValue,
                materialinerid: this.videoId,
                name: this.videoNewName
            }
            updateVideoName({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    if (data.code === '000') {
                        this.getAllVideo()
                        this.$message.success(`修改成功!`)
                        this.$refs.coverfile.initUploadParam()
                    }
                    this.editTips = false
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 删除单个视频弹窗
        allDelete(id) {
            this.$confirm('确认删除该视频么？', '删除视频', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var params = {
                    materialinerid: id,
                    materialtype: 1
                }
                this.setLoading(true)
                wholedelete({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        console.log('删除视频data:', data)
                        this.getAllVideo()
                        this.findAllCapacity()
                        this.$message.success(`删除成功`)
                    },
                    error: data => {
                        console.log('error：', data)
                        this.setLoading(false)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        // 移除分组视频素材
        delClick(value) {
            this.$confirm('确认移除该视频么？', '移除分组', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var params = {
                    materialinerid: value,
                    materialtype: 1,
                    catalogInnerId: this.groupId
                }
                this.setLoading(true)
                delMaterial({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        console.log('删除视频data:', data)
                        this.getGroupVideo(this.groupId)
                        this.$message.success(`移除成功`)
                    },
                    error: data => {
                        console.log('error：', data)
                        this.setLoading(false)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        // 左侧视频合集菜单重命名
        rename(value, id, name) {
            this.renameIndex = value
            this.catalogInnerId = id
            this.newName = name
            this.reNameCollTips = true
        },
        // 确认重命名
        sureRename() {
            if (this.newName === '') {
                this.$message.error(`新的合集名不能为空！`)
                return
            }
            var params = {
                catalogInnerId: this.catalogInnerId, // 素材分类的innerid
                name: this.newName // 重命名名称
            }
            this.setLoading(true)
            videoColReName({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    // this.getColListData()
                    this.videoCollection[this.renameIndex].catename = this.newName
                    this.reNameCollTips = false
                    this.$message.success(`修改成功`)
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 删除左侧视频合集
        delVideoCollection(i, value) {
            // this.leftMenuIsSelect = i
            this.$confirm('确认删除该合辑么？', '删除合集', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var params = {
                    catalogInnerId: value,
                    materialtype: 1
                }
                this.setLoading(true)
                delMaterialGroup({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        // console.log('删除合集data:', data)
                        // this.getColListData()
                        this.leftMenuIsSelect = 0
                        this.groupId = ''
                        this.currentPageGroupId = ''
                        this.getAllVideo()
                        this.$message.success(`删除成功`)
                    },
                    error: data => {
                        console.log('error：', data)
                        this.setLoading(false)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        // 获取合集列表data
        getColListData() {
            this.setLoading(true)
            var params = {
                materialtype: 1
            }
            getColList({
                data: Object.assign({}, params),
                success: data => {
                    this.videoCollection = data.data
                    this.setLoading(false)
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 获取所有的视频信息
        getAllVideo() {
            this.setLoading(true)
            findAllVideo({
                data: Object.assign({}, this.pageParams),
                success: data => {
                    this.setLoading(false)
                    // console.log('所有的图片信息data:', data)
                    if (this.pageParams.page === 1) {
                        this.videoCollection = data.data.cataloglist
                    }
                    this.videoListData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    // console.log(data.data[0].coveratturl)
                    // window.open(data.data[0].coveratturl)
                    // window.open("http://www.runoob.com")
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {},
    filters: {},
    computed: {
        ...mapGetters([
            'page',
            'user',
            'permission'
        ])
    },
    components: {
        UploadFile,
        Upload
    }
}
</script>

<style lang="scss" scoped type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/mixin";
    .menu_box{
        border-bottom: 1px solid #DCDFE6;
        height: 48px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        padding: 0 40px 0 20px;
        .nav_box{
            // overflow: hidden;
            .el-menu.el-menu--horizontal {
                border-bottom: 1px solid #DCDFE6;
            }
            .el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
                outline: 0;
                color: #409EFF;
            }
            .el-menu--horizontal>.el-menu-item {
                float: left;
                height: 47px;
                line-height: 47px;
                margin: 0;
                color: #303133;
                font-size:14px;
                font-family:PingFangSC-Regular;
            }
        }
        .volume_box{
            margin-top: 12px;
            background:rgba(245,247,250,1);
            border-radius: 100px;
            overflow: hidden;
            height: 24px;
            width: 140px;
            display: flex;
            align-items: center;
            position: relative;
            div:nth-of-type(1){
                width:0px;
                height:24px;
                background:rgba(64,158,255,1);
            }
            div:nth-of-type(2){
                position: absolute;
                top: 0;
                right: 0;
                width: 140px!important;
                text-align: center;
                height:24px;
                line-height:24px;
                width: 116px;
                border-radius:0 13px 13px 0;
                font-size:12px;
                font-family:PingFangSC-Regular;
                color:rgba(48,49,51,1);
            }
        }
    }
    .video {
        padding-top: 30px;
        display: flex;
        min-width: 1240px;
        .left_menu_box{
            width: 240px;
            min-height: 500px;
            margin-right: 40px;
            border-right: 1px solid #DCDFE6;
            box-sizing: border-box;
            &>div{
                text-align: right;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                width: 240px;
                font-size:14px;
                font-family:PingFangSC-Regular;
                font-weight:400;
                padding-right: 40px;
                color:rgba(48,49,51,1);
                box-sizing: border-box;
            }
            &>div:hover{
                background:rgba(230,241,252,1);
            }
            .is_select{
                background:rgba(230,241,252,1);
                border-right: 4px solid #409EFF;
                color:rgba(64,158,255,1);
                padding-right: 15px;
                .el-dropdown-link{
                    color:rgba(64,158,255,1);
                }
            }
            .top_box{
                text-align: right;
                padding-right: 36px;
                cursor: pointer;
            }
            .video_list{
                padding-right: 15px;
                .el-dropdown-link {
                    cursor: pointer;
                }
                .el-icon--right {
                    margin-left: 10px;
                }
                .el-dropdown {
                    span{
                        display: inline-block;
                        width: 180px;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                    }
                }
            }
            .add_box{
                img{
                    width: 12px;
                    height: 12px;
                    &:hover{
                        cursor: pointer;
                    }
                }
                span{
                    padding-left: 20px;
                    &:hover{
                        cursor: pointer;
                    }
                }
            }
        }
        .right_main_box{
            width: 100%;
            min-width: 500px;
            min-height: 500px;
            padding-right: 40px;
            .top{
                height: 80px;
                border-bottom: 1px solid #DCDFE6;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                margin-bottom: 10px;
                .left_box{
                    display: flex;
                    .upload_box{
                        margin-right: 15px;
                    }
                    .tips_box{
                        width: 570px;
                        font-size:13px;
                        line-height:20px;
                        color:#909399;
                    }
                }
                .right_box{
                    display: flex;
                    span{
                        margin-right: 15px;
                        margin-left: 20px;
                        // margin-top: 8px;
                        line-height:28px;
                        display: inline-block;
                        color:rgba(96,98,102,1);
                        white-space: nowrap;
                    }
                    button{
                        width:28px;
                        height:28px;
                        background:rgba(64,158,255,1);
                        color: #fff;
                        border: none;
                        border-radius: 100%;
                    }
                }
            }
            .video_content_list{
                .no_content{
                    background-image: url('../../../common/images/other/zwsj@2x.png');
                    background-size:372px 269px !important;
                    background-position:top center !important;
                    background-repeat: no-repeat;
                    height: 500px;
                    // margin-top: 30px;
                    color:rgba(144,147,153,1);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .video_content_box{
                    .video_box{
                        display: flex;
                        flex-wrap: wrap;
                        .video_item{
                            width: 50%;
                            min-width: 420px;
                            display: flex;
                            // margin-right: 50px;
                            margin-bottom: 50px;
                            &>div:nth-of-type(1) {
                                width: 160px;
                                height: 90px;
                                position: relative;
                                cursor: pointer;
                                .video_item_box{
                                    width: 160px;
                                    height: 90px;
                                    position: relative;
                                    background-color: black;
                                    img{
                                        width: 160px;
                                        height: 90px;
                                    }
                                    span {
                                        position: absolute;
                                        bottom: 2px;
                                        left: 6px;
                                        color: #fff;
                                    }
                                }
                                .play_video_box{
                                    background-color: rgba(0,0,0,.4);
                                    width: 160px;
                                    height: 90px;
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    display: none;
                                    img{
                                        width: 24px;
                                        height: 24px;
                                        position: absolute;
                                        top: 0;
                                        left: 0;
                                        bottom: 0;
                                        right: 0;
                                        margin: auto;
                                    }
                                }
                            }
                            &>div:nth-of-type(1):hover{
                                .play_video_box{
                                    display: block;
                                }
                            }
                            &>div:nth-of-type(2){
                                width: 292px;
                                margin-left: 10px;
                                padding: 5px 0;
                                display: flex;
                                flex-direction: column;
                                justify-content: space-between;
                                &>div:nth-of-type(1){
                                    color: #303133;
                                }
                                &>div:nth-of-type(2){
                                    label{
                                        color: #C0C4CC;
                                        margin-right: 10px;
                                    }
                                    &>span{
                                        color: #409EFF;
                                        margin-right: 10px;
                                    }
                                    &>span:hover{
                                        color: rgb(12, 130, 248);
                                        cursor: pointer;
                                    }
                                }
                            }
                        }
                        .edit_box{
                            display: flex;
                            .left_box{
                                width: 160px;
                                height: 120px;
                                margin-right: 15px;
                                position: relative;
                                display: flex;
                                justify-content: space-between;
                                flex-direction: column;
                                &>div:nth-of-type(1){
                                    width: 160px;
                                    height: 90px;
                                    &>span{
                                        color: #909399;
                                        display: inline-block;
                                        width: 100%;
                                        text-align: center;
                                    }
                                }
                            }
                            .right_box{
                                width: 380px;
                                height: 67px;
                                .el-textarea__inner {
                                    line-height: 1.95;
                                }
                            }
                        }
                        .classify_box{
                            min-height: 60px;
                            max-height: 200px;
                            overflow-y:auto;
                            .el-checkbox {
                                margin-bottom: 10px;
                                // margin-right: 40px;
                                width: 160px;
                                overflow: hidden;
                                text-overflow:ellipsis;
                                white-space: nowrap;
                            }
                            .el-checkbox:nth-of-type(3n) {
                                margin-right: 0px;
                            }
                        }
                        .download_box{
                            height: 50px;
                            text-align: center;
                            p{
                                text-align: left;
                                margin-bottom: 10px;
                            }
                        }
                        .download_btn{
                            margin-left: 0;
                        }
                    }
                    .page {
                        @include flexBox(center)
                    }
                }
            }
        }
        .video_tips{
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            overflow: auto;
            z-index: 2020;
            background-color: rgba(0,0,0,.4);
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            &>div{
                width: 960px;
                position: relative;
                img{
                    width: 26px;
                    height: 26px;
                    position: absolute;
                    top: -36px;
                    right: -36px;
                    cursor: pointer;
                    animation: closeIcon 1s infinite;
                    animation-duration: 1s;
                    animation-timing-function: ease;
                    animation-delay: 0s;
                    animation-iteration-count: infinite;
                    animation-direction: normal;
                    animation-fill-mode: none;
                    animation-play-state: running;
                    animation-name: closeIcon;
                }
                img:hover{
                    -webkit-transform:rotate(180deg);
                    transform:rotate(180deg);
                    -webkit-transition:-webkit-transform 0.5s linear;
                    transition:transform 0.5s linear;
                }
                @keyframes closeIcon {
                    0% {
                        bottom: 5%;
                        opacity: .3;
                    }
                    50% {
                        bottom: 4.5%;
                        opacity: 1;
                    }
                    100% {
                        bottom: 5%;
                        opacity: .3;
                    }
                }
            }
        }
    }
    .el-dropdown-menu{
        .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
            background-color: #ffffff;
        }
        .el-dropdown-menu__item {
            justify-content: center;
        }
        .el-dropdown-menu__item:nth-of-type(2) {
            border-top: 1px solid #ccc;
        }
    }
</style>
<style lang="scss" scoped type="text/scss" rel="stylesheet/scss">
    .warp{
    .el-dialog__wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: left;
    }
    .el-dialog {
        margin: 0!important;
    }
    .upload .avatar {
        width: 160px!important;
        height: 90px!important;
    }
    .upload {
        margin-bottom: 15px;
    }
    }

</style>
